import React, { useState } from "react"
import { Grid, GridColumn as Column, GridDataStateChangeEvent, GridCellProps } from "@progress/kendo-react-grid";
import { VerificationViewCell } from "./VerificationViewCell";
import { useNavigate, useParams } from "react-router";
import { useWorklistQuery } from "../../../../services/verifyService/verify-api";
import { ColumnMenu } from "../../../../utils/ColumnMenu";
import { Worklist } from "../../../../services/verifyService/model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Typography, Button, Chip } from "@mui/material";
import { WorklistRequest } from "../../../../services/verifyService/commands";
import { process, SortDescriptor, State } from "@progress/kendo-data-query";

const StatusCell = (props: GridCellProps) => {
    if (!props.dataItem.hasRequest) {
        return <td></td>;
    }
    
    return (
        <td>
            <Chip 
                label={props.dataItem.isResolved ? "Resolved" : "Unresolved"} 
                color={props.dataItem.isResolved ? "success" : "warning"}
                size="small"
            />
        </td>
    );
};

function EscalatedWorklist(){
    const {type,center,filter} = useParams();
    const {data} = useWorklistQuery(new WorklistRequest(type!,center!,filter!));
    const navigate = useNavigate();
    
    const mapCases=():Worklist[]=>{
        let cases:Worklist[]=data===undefined ? [] : data?.map(i => ({
            ...i, 
            serviceDate: new Date(i.serviceDate),
            requestStatusSort: !i.hasRequest ? 0 : (i.isResolved ? 2 : 1)
        }))
        
        return cases;
    }
    
    const initialSort:SortDescriptor[] = [{field:'serviceDate', dir:'asc'}];
    const defaultGridState:State = {sort:initialSort};
    const [dataState, setDataState] = useState(defaultGridState);
    
    const createDataState = (dataState: State) => {
        return {
          dataState: dataState === undefined ? {} :dataState,};
    }; 
    
    const dataStateChange = (event: GridDataStateChangeEvent) => {
        let updatedState = createDataState(event.dataState);
        setDataState(updatedState.dataState);
    };

    return <React.Fragment>
        <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{ mb: 2 }}>
            <Typography className="psn-green" variant='h6'>{type === 'Escalated' ? 'Facility Request Worklist' : type + ' Worklist'}</Typography>
            <Stack direction='row' spacing={2} alignItems='center'>
                <Button variant='outlined' onClick={()=>navigate(-1)} color='success'>
                    <FontAwesomeIcon icon={'arrow-left'}/>
                    <span className="ms-1">Go Back</span>
                </Button>
            </Stack>
        </Stack>

        <Grid
            key={`${type}-${center}-${filter}`}
            data={process(mapCases(), dataState)}
            {...dataState}
            style={{ height: '750px', width: '100%' }}
            sortable={{mode:'multiple'}}
            groupable={false}
            onDataStateChange={dataStateChange}
        >
            <Column cell={VerificationViewCell} width={'75px'} groupable={false}/>
            {center === 'ALL' && <Column field="centerName" title="Center" width="150px" columnMenu={ColumnMenu} />}
            {center === 'ALL' && <Column field="npi" title="NPI" width="150px" columnMenu={ColumnMenu} />}
            <Column title='Patient' field='patient' columnMenu={ColumnMenu} width={'200px'}/>
            <Column title='Account' field='account' columnMenu={ColumnMenu} width={'150px'}/>
            <Column title='Service Date' field='serviceDate' columnMenu={ColumnMenu} format='{0:MM/dd/yyyy}' filter="date" width={'140px'}/>
            <Column title='Payer' field="payerName" columnMenu={ColumnMenu} width={'250px'}/>
            <Column title='Benefits Status' field='benefitsStatus' columnMenu={ColumnMenu} width={'150px'}/>
            <Column title='Auth Status' field='authStatus' columnMenu={ColumnMenu} width={'150px'}/>
            <Column title='Request Status' field='requestStatusSort' cell={StatusCell} columnMenu={ColumnMenu} width={'180px'}/>
        </Grid>
    </React.Fragment>
}

export {EscalatedWorklist}
